import {apiConstants} from "@data/constants/apiConstants";
import {interviewReportService} from "@data/services/interviewReportService";

const initialState = {
    interviewReportsList: [],
    prioritizedSchoolSubjects: [],
}

export default function interviewReports(state = initialState, action) {
    switch (action.type) {
        case interviewReportService.getStudentInterviewReports.name + apiConstants._SUCCESS:
            let interviewReportsList = []
            if (action.data?.meta?.current_page === 1) {
                interviewReportsList = action.data?.interview_reports
            } else {
                interviewReportsList = state.interviewReportsList.concat(action.data?.interview_reports)
            }
            return {
                ...state,
                interviewReportsList: interviewReportsList,
                prioritizedSchoolSubjects: action.data?.prioritized_school_subjects
            }
        case interviewReportService.getInterviewReport.name + apiConstants._SUCCESS:
        return {
                ...state,
                interviewReportsList: [action.data, ...state.interviewReportsList]
            }
        default:
            return state
    }
}
